import { RouteObject } from 'react-router-dom'
import RouterError from '../RouterError'
import { RequesterEmailValidationContainer } from '../../components/Requester/RequesterEmailValidation/RequesterEmailValidationContainer'

export const publicRoutes: RouteObject = {
    path: '/public',
    errorElement: <RouterError />,

    children: [
        {
            path: 'transmissions/:transmissionId/requesters/:token/decision/:decision',
            element: <RequesterEmailValidationContainer />,
        },
    ],
}
